import situationRoomDefaultTheme from './situationRoomDefault';
import ifrcTheme from './ifrc';
import immapTheme from './immap';
import unitedNationsTheme from './unitedNations';
import nrcTheme from './nrc';

export const themes = {
  'situation-room-default': situationRoomDefaultTheme,
  'ifrc': ifrcTheme,
  'immap': immapTheme,
  'united-nations': unitedNationsTheme,
  'nrc': nrcTheme,
};

export default themes; 